<template>
  <div>
    <the-headersider />

    <!-- Header -->
    <base-card class="header-card">
      <div class="header-row">
        <div>
          <h2 class="title">
            {{ estate.name }} Estate
          </h2>
          <p class="subtitle">
            {{ filteredClients.length }} Clients Registered
          </p>
        </div>

        <input
          type="search"
          class="search"
          v-model="search"
          placeholder="Search by name or phone"
        />
      </div>
    </base-card>

    <!-- Clients Table -->
    <base-card>
      <div class="table-wrapper">
        <table class="table fancy-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Arrears</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="filteredClients.length === 0">
              <td colspan="3" class="empty">
                No clients found
              </td>
            </tr>

            <tr
              v-for="client in filteredClients"
              :key="client.id"
            >
              <td class="name">
                <router-link
                  :to="'/client/payments/' + client.client_id"
                >
                  {{ client.name }}
                </router-link>
              </td>

              <td>{{ client.phone }}</td>

              <td>
                <span
                  class="arrears"
                  :class="{ danger: client.arrears > 0 }"
                >
                  KES {{ formatAmount(client.arrears) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Actions -->
      <div class="actions">
        <button class="btn btn-success" @click="downloadPDF">
          Download Estate Clients PDF
        </button>

        <router-link
          to="/register/clients"
          class="btn btn-primary"
        >
          + Register Client
        </router-link>
      </div>
    </base-card>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  data() {
    return {
      search: "",
    };
  },

  computed: {
    clients() {
      return this.$store.getters.clients;
    },

    estate() {
      return this.$store.getters.estateName(this.$route.params.estate);
    },

    estateClients() {
      return this.$store.getters.estateClientsGetter(
        this.$route.params.estate
      );
    },

    filteredClients() {
      const key = this.search.toLowerCase();

      return this.estateClients.filter(
        c =>
          c.name.toLowerCase().includes(key) ||
          c.phone.toString().includes(key)
      );
    },
  },

  created() {
    this.$store.dispatch("LoadClients");
    this.$store.dispatch("LoadEstates");
  },

  methods: {
    formatAmount(val) {
      return Number(val || 0).toLocaleString();
    },

    downloadPDF() {
      const pdf = new jsPDF();

      const columns = ["Name", "Phone", "Arrears"];
      const rows = this.estateClients.map(c => [
        c.name,
        c.phone,
        `KES ${this.formatAmount(c.arrears)}`,
      ]);

      pdf.setFontSize(14);
      pdf.text(
        `Clients for ${this.estate.name} Estate`,
        14,
        20
      );

      pdf.autoTable({
        head: [columns],
        body: rows,
        startY: 30,
      });

      pdf.save(`${this.estate.name}-clients.pdf`);
    },
  },
};
</script>

<style scoped>
/* Header */
.header-card {
  margin-bottom: 1rem;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.title {
  font-size: 1.4rem;
  font-weight: 700;
}

.subtitle {
  color: #6b7280;
  font-size: 0.9rem;
}

/* Search */
.search {
  padding: 0.6rem;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  width: 250px;
}

/* Table */
.table-wrapper {
  overflow-x: auto;
}

.fancy-table th {
  background: #f9fafb;
}

.name a {
  font-weight: 600;
  color: #2563eb;
  text-decoration: none;
}

.name a:hover {
  text-decoration: underline;
}

.arrears {
  font-weight: 700;
  color: #16a34a;
}

.arrears.danger {
  color: #dc2626;
}

.empty {
  text-align: center;
  padding: 1rem;
  color: #6b7280;
}

/* Actions */
.actions {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}
</style>
